<template>
  <section
    role="region"
    class="contact-list-section"
    id="contact-list"
    v-if="!loadingFaqs"
  >
    <TheFaqList :faqs="faqs" />
  </section>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useGlobalStore } from "@/stores/global";
const store = useGlobalStore();
const { faqs, loadingFaqs } = storeToRefs(store);

onMounted(async () => {
  try {
    await store.getFaqs();
  } catch (e) {
    console.error(e);
  }
});
</script>

<style lang="scss">
@use "@/styles/variables" as *;

.contact-list-section {
  .section-name {
    text-align: center;
    margin: 18px 0px 20px;
  }

  .panels {
    max-width: 700px;
    margin: 0px auto;

    .panel {
      border-radius: 10px !important;
      border: 1px solid #c4c4c4;
      margin-bottom: 16px;

      .v-expansion-panel-title {
        color: $greyDark;
        font-size: 16px;
        font-weight: 600;
        line-height: normal;
        align-items: flex-start;
        padding: 13px 12.5px 13px 20px;

        .mdi {
          margin-top: 4px;
          color: $blue;
        }

        &:hover {
          color: $blue;
        }

        &:hover > .v-expansion-panel-title__overlay {
          background-color: $white;
        }
      }

      .v-expansion-panel-text__wrapper {
        padding: 2px 24px 16px;

        ul li {
          width: 90%;
          margin: 0 auto;
        }
      }

      .v-expansion-panel-title--active {
        color: $blue;

        & > .v-expansion-panel-title__overlay {
          opacity: 0;
        }
      }

      &:hover {
        border-color: $blue;
      }
    }

    .v-expansion-panel--active {
      border-color: $blue !important;
    }
  }

  @media screen and (min-width: 834px) and (max-width: 1199px) {
    .panels {
      padding: 0px 34px;
    }
  }

  @media screen and (min-width: 834px) {
    .section-name {
      margin: 20px 0px 30px;
    }

    .panels .panel {
      margin-bottom: 20px;
    }
  }
}
</style>
